import script from "./DeviceWorkTimeStats.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceWorkTimeStats.vue?vue&type=script&setup=true&lang=js"

import "./DeviceWorkTimeStats.vue?vue&type=style&index=0&id=9aa87374&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9aa87374"]])

export default __exports__